import { render, staticRenderFns } from "./app-filter-item.vue?vue&type=template&id=5df634cc&scoped=true&"
import script from "./app-filter-item.vue?vue&type=script&lang=js&"
export * from "./app-filter-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df634cc",
  null
  
)

export default component.exports